import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import TopHeadlinesCard from '../News/TopHeadlinesCard/TopHeadlinesCard';
import DashboardSpotlightCarousel from './DashboardSpotlightCarousel/DashboardSpotlightCarousel';
import RostersListCard from '../Rosters/RostersListCard/RostersListCard';
import CoursesListCard from '../Courses/CoursesListCard/CoursesListCard';
import SocialPostsEmbed from '../SocialPostsEmbed/SocialPostsEmbed';
import DashboardVideoCarousel from '../Dashboard/DashboardVideoCarousel/DashboardVideoCarousel';
import PricingTable from '../PricingTable/PricingTable';
const Dashboard = ({
	get_articles_endpoint,
	get_player_endpoint,
	get_team_endpoint,
	get_prospect_endpoint,
	get_courses_endpoint,
	get_rosters_by_user_endpoint,
	get_social_posts_endpoint,
	create_checkout_session_endpoint,
	stripe_public_key,
	stripe_product_essential_id,
	stripe_product_advanced_id,
	stripe_product_ultimate_id
}) => {
	const { user } = useAuth();
	const modalRef = useRef(null);
	const [
		isPricingTableModalOpen,
		setIsPricingTableModalOpen
	] = useState(false);

	const closePricingTableModal = () => {
		setIsPricingTableModalOpen(false);
	};

	const closePricingTableModalOnClickOutside = (event) => {
		if (modalRef.current && !modalRef.current.contains(event.target)) {
			setIsPricingTableModalOpen(false);
		}
	};

	useEffect(
		() => {
			if (isPricingTableModalOpen) {
				document.addEventListener(
					'mousedown',
					closePricingTableModalOnClickOutside
				);
			} else {
				document.removeEventListener(
					'mousedown',
					closePricingTableModalOnClickOutside
				);
			}
			return () => {
				document.removeEventListener(
					'mousedown',
					closePricingTableModalOnClickOutside
				);
			};
		},
		[
			isPricingTableModalOpen
		]
	);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div>
			{user &&
			user.first_name && (
				<header className="pb-3 lg:pb-6">
					<h1 className="text-2xl lg:text-4xl font-bold text-gray-800 dark:text-dark-text">
						Welcome back, {user.first_name} 👋
					</h1>
				</header>
			)}

			<main>
				<div className="grid grid-cols-12 gap-6">
					{/* Top Headlines */}
					<div className="col-span-12 xl:col-span-3">
						<TopHeadlinesCard get_articles_endpoint={get_articles_endpoint} />
					</div>

					{/* Spotlight Section */}
					<div className="col-span-12 xl:col-span-9">
						<DashboardSpotlightCarousel
							get_player_endpoint={get_player_endpoint}
							get_team_endpoint={get_team_endpoint}
							get_prospect_endpoint={get_prospect_endpoint}
						/>
					</div>
				</div>

				{/* Cards Section */}
				<div className="col-span-12 grid grid-cols-1 md:grid-cols-1 gap-6 mt-6">
					{/* Rosters */}
					<RostersListCard
						user={user}
						get_rosters_by_user_endpoint={get_rosters_by_user_endpoint}
					/>

					{/* Courses */}
					{/*	<CoursesListCard get_courses_endpoint={get_courses_endpoint} /> */}
				</div>

				{/* Cards Section Pt. 2 */}
				<div className="grid grid-cols-12 gap-6 mt-6">
					{/* Twitter Feed */}
					<div className="col-span-12 xl:col-span-4">
						<SocialPostsEmbed
							get_social_posts_endpoint={get_social_posts_endpoint}
						/>
					</div>

					{/* Featured Videos */}
					<div className="col-span-12 xl:col-span-8">
						<DashboardVideoCarousel get_player_endpoint={get_player_endpoint} />
					</div>
				</div>
			</main>

			{/* Pricing Table */}
			{isPricingTableModalOpen && (
				<div
					className="fixed inset-0 flex justify-center items-center"
					style={{
						zIndex: 1000,
						backgroundColor: 'rgba(0, 0, 0, 0.5)'
					}}
				>
					<div
						ref={modalRef}
						className="relative bg-white rounded-lg p-6 shadow-lg"
						style={{ width: 'auto', maxHeight: 'auto', overflowY: 'auto' }}
					>
						<button
							className="absolute top-0 right-0 p-4"
							onClick={closePricingTableModal}
						>
							<svg
								className="h-6 w-6 text-gray-500"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
						<h2 className="text-2xl font-bold mb-4">Our Pricing</h2>
						<div className="overflow-x-auto">
							<div className="flex flex-col">
								<PricingTable
									create_checkout_session_endpoint={
										create_checkout_session_endpoint
									}
									stripe_public_key={stripe_public_key}
									stripe_product_essential_id={stripe_product_essential_id}
									stripe_product_advanced_id={stripe_product_advanced_id}
									stripe_product_ultimate_id={stripe_product_ultimate_id}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default Dashboard;
